<template>
  <v-data-table
    :headers="tableheaders"
    :items="palletBreakdowns"
    :items-per-page="1000"
    hide-default-footer
    item-key="pallet_num"
    class="elevation-1"
  >
    <template v-slot:body="{ items: palletBreakdowns }">
      <tbody>
        <tr>
          <td>
            <v-btn
              @click="doLoadAll"
              :disabled="pending || isCreditHold"
              :loading="pending"
              width="120"
            >
              Load All
            </v-btn>
          </td>
        </tr>
        <load-pallet-breakdown
          v-for="breakdown in palletBreakdowns"
          :key="breakdown.pallet_num"
          :palletBreakdown="breakdown"
          :palletBreakdownHeader="palletBreakdownHeader"
          :load="load"
        />
      </tbody>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import LoadPalletBreakdown from './LoadPalletBreakdown';

export default {
  name: 'LoadPalletBreakdowns',
  data() {
    return {
      tableheaders: [
        { text: 'Load Status', sortable: false, align: 'center' },
        { text: 'Initials', value: 'initials' },
        { text: 'Date Scanned', value: 'date_scanned' },
        { text: 'Time Scanned', value: 'time_scanned' },
        { text: 'Pallet #', value: 'pallet_num' },
        { text: 'Qty Per Pallet', value: 'quantity_per_pallet', align: 'left' }
      ]
    };
  },
  computed: {
    ...mapState('dock', ['dock', 'pending']),
    customer() {
      if (this.load.salesOrder) return this.load.salesOrder.customer;
      return null;
    },
    isCreditHold() {
      return this.customer && (this.customer.creditHold || this.customer.creditHoldCOD);
    }
  },
  methods: {
    ...mapActions('dock', ['loadallPallets']),
    ...mapMutations('dock', ['setPending']),
    async doLoadAll() {
      if (this.pending) return;
      try {
        this.setPending(true);
        await this.loadallPallets({
          palletBreakdowns: this.palletBreakdowns,
          payload: {
            dock_num: this.dock.number,
            sprunnuma: this.load.sprunnum
          }
        });
      } finally {
        this.setPending(false);
      }
    }
  },
  props: ['load', 'palletBreakdowns','palletBreakdownHeader'],
  components: { LoadPalletBreakdown }
};
</script>
